
<script>
import BarList from '../components/bar-list'
import UsuarioForm from './usuario-form'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            usuario: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
        }
    },

    computed: {
        usuarioList: function () {
            return this.$store.getters.getUsuarioList
        },
        perfil_usuario_comum: function () {
            const perfil = this.$store.getters.getSessao.perfil
            return perfil > '2'
        },
        usuario_logado_uuid: function () {
            return this.$store.getters.getEnv.uuid
        },
    },

    filters: {
        getText: function (value) {
            if (value == 'A') {
                return 'Ativo'
            } else { return 'Inativo'}
        },

        getPerfil: function (value) {
            if (value == '1')
               return 'Administrador'
            else
            if (value == '0')
               return 'Responsável criador'
            else
            if (value == '3')
               return 'Representante'
            else
            if (value == '5')
               return 'PDV-Varejo'
            else
            if (value == '2')
               return 'Gerente'
            else
               return 'Normal'
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codusuario = cod
            this.showForm = true;
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codusuario = ''
            this.showForm = true;
        },

        closeForm() {
            this.loadData()
            this.showForm = false
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codusuario":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadUsuario', { filter: this.filter } )
        }

    },

    components: {
        BarList, UsuarioForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="!perfil_usuario_comum"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Usuário"
                plural-entity="Usuários"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo nome">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="usuarioList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="usuario in usuarioList" :key="usuario.codusuario">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ usuario.nome }}</h2>
                                    <span class="nb-card-badge" :class="usuario.stusuario == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'">
                                        {{ usuario.stusuario | getText }}
                                    </span>
                                    <span class="nb-card-badge nb-card-badge--neutral">
                                        {{ usuario.perfil | getPerfil }}
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="usuario.codusuario">
                                    Código <strong>{{ usuario.codusuario }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <v-button 
                                v-if="!perfil_usuario_comum || usuario.uuid===usuario_logado_uuid" 
                                label="Alterar" 
                                :nb-btdef="true" 
                                icon="fa-pencil" 
                                @click="handleEdit(usuario.codusuario)">
                            </v-button>
                        </div>
                    </div>

                    <div class="nb-card-details" v-if="usuario.email || usuario.fone">
                        <div class="nb-card-detail" v-if="usuario.email">
                            <span class="nb-card-detail-label">E-mail</span>
                            <strong><i class="fa fa-envelope-o" aria-hidden="true"></i> {{ usuario.email }}</strong>
                        </div>
                        <div class="nb-card-detail" v-if="usuario.fone">
                            <span class="nb-card-detail-label">Telefone</span>
                            <strong><i class="fa fa-phone" aria-hidden="true"></i> {{ usuario.fone | formatFone }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <transition name="fade">
            <usuario-form v-if="showForm" :index="this.codusuario" :crud="this.crud" v-on:closeform="closeForm"></usuario-form>
        </transition>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-badge--neutral {
  color: #475569;
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.nb-card-detail > strong .fa {
  margin-right: 4px;
  color: #64748b;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/usuario-list.vue